module.exports = __webpack_public_path__ + "static/media/bg-content-home.83c14104.png";